import { tablesSelector } from '@store/selectors/tables';
import { tables } from '@store/tables';
import { isBlackjack } from '@utils/functions';
import { produce } from 'immer';
import { of } from 'rxjs';

import { getMaxHistoryByGame } from './functions';

export default function handleTableHistory(socketMessage, state) {
  const { tableId, TableId, History, GameResults, AvailableSeats } = socketMessage;
  const id = tableId || TableId;

  let table = tablesSelector(state)[id];

  if (!table) {
    table = { tableId: id, history: [] };
  }

  const { history, playersCount, gameId } = table;

  let newPlayerCount = playersCount;

  const nextHistory = produce(history, (draftState) => {
    if (typeof History !== 'undefined') {
      draftState = History.slice(
        -getMaxHistoryByGame(table.gameId)
      );
    }
    if (typeof GameResults !== 'undefined') {
      draftState.push(GameResults);
    }
    if (typeof AvailableSeats !== 'undefined') {
      draftState = AvailableSeats;
    }

    if (isBlackjack(gameId)) {
      newPlayerCount = draftState.filter(
        (seat) => seat.SeatId !== 'd' && seat.Taken
      ).length;
    }

    return draftState;
  });

  return of(
    tables.updateTable([
      {
        tableId: id,
        history: nextHistory,
        playersCount: newPlayerCount,
      },
    ])
  );
}
